module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"areYouSure":"Er du sikker?"}}')
  delete Component.options._Ctor
}
